/**
 * Интервалы кеширования для staleTime и gcTime TanStack Query.
 * Названия по типу обновления — значение меняется только здесь.
 */
export const QUERY_CACHE_TIMES = {
  /* Всегда считать данные устаревшими (0 минут) */
  ALWAYS_REFETCH: 0,
  /** Быстрое обновление (5 минут) */
  FAST_UPDATE: 5 * 60 * 1000, // 5 минут
  /** Обычное кеширование (10 минут) */
  NORMAL_UPDATE: 10 * 60 * 1000, // 10 минут
  /** Долгое кеширование (1 час) */
  LONG_UPDATE: 60 * 60 * 1000, // 1 час
  /** Очень долгое кеширование (24 часа) */
  VERY_LONG_UPDATE: 24 * 60 * 60 * 1000, // 24 часа
} as const;
